import type { SVGProps } from 'react';
const DawnFlagLS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-LS_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-LS_svg__a)">
      <path fill="#0C33B8" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <path fill="#1DB158" fillRule="evenodd" d="M0 16h22v-5.333H0z" clipRule="evenodd" />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="M10.477 8a.551.551 0 0 1 1.047 0l.9 1.375c.087.132.067.303-.064.388-.244.157-.697.37-1.36.37-.662 0-1.115-.213-1.359-.37-.131-.085-.15-.256-.065-.388z"
        clipRule="evenodd"
      />
      <path
        stroke="#262626"
        strokeWidth={0.667}
        d="M11.714 6.933c0 .411-.325.734-.714.734a.724.724 0 0 1-.714-.734c0-.41.325-.733.714-.733s.714.323.714.733Z"
      />
    </g>
  </svg>
);
export default DawnFlagLS;
